import Button from './Button';
import forwardRef from '../utils/forwardRef';
export default forwardRef({
  name: 'Button',
  ClassComponent: Button
});